import { Tabs } from "antd";
import React, { useCallback, useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import WithSidebar from "../../templates/withSidebar";
import VocCurrentReport from './current';
import SearchVocProvider from './current/searchContext';
import VocFutureReport from './future'
import SearchFutureVocProvider from './future/searchContext';
import useVocReportTabs from '../../lib/hooks/useVocReportTab';
const VocReport = () => {
    const navigate = useNavigate();
    const { tabs, setTabs } = useVocReportTabs();
    const [searchParams] = useSearchParams();
    const currentMenu = searchParams.get("management");
    const currentTab = searchParams.get("tab");

    const setChangeTabfromState = useCallback(
        (tab) => {
        setTabs(tab);
        },
        [setTabs]
    );

    useEffect(() => {
        setChangeTabfromState(currentTab);
    }, [currentMenu, currentTab]);

    const onChangeTab = (key) => {
        setTabs(key);
        navigate({
        pathname: `/voc-report`,
        search: `?menu=progress&tab=${key}`,
        });
    };

    const items = [
        {
        key: "current",
        label: <strong>ลูกค้าปัจจุบัน</strong>,
        children: (
            <SearchVocProvider>
                <VocCurrentReport/>
            </SearchVocProvider>
        ),
        },
        {
        key: "future",
        label: <strong>ลูกค้าอนาคต</strong>,
        children: (
            <SearchFutureVocProvider>
                <VocFutureReport/>
            </SearchFutureVocProvider>
        ),
        },
    ];
    return (
        <WithSidebar>
            <Tabs activeKey={tabs} items={items} onChange={onChangeTab} />
        </WithSidebar>

    )
};

export default VocReport;